import React from "react";
import { TemplateWrapped } from "../../Layout";
import CustomPanel from "../../CustomPanel";
import { useRealTimeReport } from "./hooks/useRealTimeReport";
import { Button, Col, Row, Form } from "react-bootstrap";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Formik, Form as FormikForm, ErrorMessage } from "formik";

const RealTimeReport = () => {
  const {
    clients,
    setClientSelected,
    practices,
    handleSubmit,
    isDownloading,
    createValidationSchema,
  } = useRealTimeReport();

  return (
    <TemplateWrapped>
      <CustomPanel>
        <Formik
          initialValues={{
            idClient: null,
            //clinicId: null,
            startDate: "",
            endDate: "",
          }}
          validationSchema={createValidationSchema()}
          onSubmit={async (values) => {
            await handleSubmit(values);
          }}
        >
          {({ setFieldValue, values }) => (
            <FormikForm>
              <Row className="justify-content-md-center mt-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Clients</Form.Label>
                    <Select
                      options={clients.map((client) => {
                        return { value: client._id, label: client.clientName };
                      })}
                      placeholder="Select an client"
                      value={values.idClient}
                      onChange={(option) => {
                        setFieldValue("idClient", option);
                        setClientSelected(option);
                      }}
                    />
                    <ErrorMessage
                      name="idClient"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </Form.Group>
                </Col>
                <Col md={3} style={{ display: "none" }}>
                  <Form.Group>
                    <Form.Label>Practices</Form.Label>
                    <Select
                      options={practices}
                      placeholder={
                        values.idClient
                          ? "Select an client first"
                          : "Select an practice"
                      }
                      value={values.clinicId}
                      onChange={(option) => setFieldValue("clinicId", option)}
                      isClearable={true}
                    />
                    <ErrorMessage
                      name="clinicId"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      id="startDate"
                      name="startDate"
                      required
                      value={values.startDate}
                      onChange={(e) =>
                        setFieldValue("startDate", e.target.value)
                      }
                    />
                    <ErrorMessage
                      name="startDate"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="date"
                      id="endDate"
                      name="endDate"
                      value={values.endDate}
                      required
                      onChange={(e) => setFieldValue("endDate", e.target.value)}
                    />
                    <ErrorMessage
                      name="endDate"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="d-flex justify-content-end">
                <Col md={3} className="align-content-center mt-4 pt-2">
                  <Form.Group>
                    <Button
                      type="submit"
                      className="btn btn-primary btn-block d-flex justify-content-center align-items-center"
                      disabled={isDownloading}
                      style={{ gap: 10 }}
                    >
                      {!isDownloading && "Generate"}
                      {isDownloading && <FontAwesomeIcon icon="spinner" spin />}
                      {isDownloading && "Generating..."}
                    </Button>
                  </Form.Group>
                </Col>
              </Row>
            </FormikForm>
          )}
        </Formik>
      </CustomPanel>
    </TemplateWrapped>
  );
};

export default RealTimeReport;
